module.exports = __webpack_public_path__ + "img/7.d0fd712b.png";